/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Self-registration payload for a Firebase-authenticated user. The runtime always creates the new user as an `owner`. The legacy `role` field is accepted for backward compatibility and ignored by the runtime.
 * 
 * @export
 * @interface RegisterUserRequest
 */
export interface RegisterUserRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    name: string;
    /**
     * Legacy compatibility field. Send `owner`; other values have no effect at runtime.
     * @type {string}
     * @memberof RegisterUserRequest
     * @deprecated
     */
    role?: RegisterUserRequestRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof RegisterUserRequest
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    firebaseProvider?: RegisterUserRequestFirebaseProviderEnum;
}


/**
 * @export
 */
export const RegisterUserRequestRoleEnum = {
    Owner: 'owner',
    Admin: 'admin',
    Member: 'member',
    Viewer: 'viewer'
} as const;
export type RegisterUserRequestRoleEnum = typeof RegisterUserRequestRoleEnum[keyof typeof RegisterUserRequestRoleEnum];

/**
 * @export
 */
export const RegisterUserRequestFirebaseProviderEnum = {
    Password: 'password',
    GoogleCom: 'google.com',
    MicrosoftCom: 'microsoft.com'
} as const;
export type RegisterUserRequestFirebaseProviderEnum = typeof RegisterUserRequestFirebaseProviderEnum[keyof typeof RegisterUserRequestFirebaseProviderEnum];


/**
 * Check if a given object implements the RegisterUserRequest interface.
 */
export function instanceOfRegisterUserRequest(value: object): value is RegisterUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function RegisterUserRequestFromJSON(json: any): RegisterUserRequest {
    return RegisterUserRequestFromJSONTyped(json, false);
}

export function RegisterUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'role': json['role'] == null ? undefined : json['role'],
        'companyId': json['companyId'],
        'firebaseProvider': json['firebaseProvider'] == null ? undefined : json['firebaseProvider'],
    };
}

export function RegisterUserRequestToJSON(json: any): RegisterUserRequest {
    return RegisterUserRequestToJSONTyped(json, false);
}

export function RegisterUserRequestToJSONTyped(value?: RegisterUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'role': value['role'],
        'companyId': value['companyId'],
        'firebaseProvider': value['firebaseProvider'],
    };
}

